/* Cross-browser support for ensuring functions fire when DOM is loaded */
if (document.readyState !== "loading") {
  initVideo();
} else {
  document.addEventListener("DOMContentLoaded", function () {
    initVideo();
  });
}

function initVideo() {
  const prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)"
  ).matches;

  // If not mobile, or user doesn't prefer reduced motion, continue.
  if (!window.matchMedia("(min-width: 768px)").matches || prefersReducedMotion)
    return;

  const wrapper = document.querySelector(".hero__video");
  if (!wrapper) return;

  const video = wrapper.querySelector("video");
  if (!video) return;

  // Keep the fallback image visible if the video can't be played.
  const showFallback = () => wrapper.setAttribute("hidden", "");
  video.addEventListener("error", showFallback);

  // Reveal and attempt playback. If the browser can't play it (unsupported
  // codec, blocked autoplay), revert to the fallback image.
  wrapper.removeAttribute("hidden");
  const playPromise = video.play();
  if (playPromise !== undefined) {
    playPromise.catch(showFallback);
  }
}
